'use client'
import React, { FunctionComponent, useCallback, useState } from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'
import { MktuClassWord } from '@/services/Api/generated'

import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { MKTU_CLASS_CATEGORY_TITLE } from '@/models/Mktu'
import { SelectedWordsList } from '@/shared/Mktu/components'

import { Button } from '@/components/Button'
import { Icon } from '@/icons'

import styles from './Card.module.scss'

interface CardProps {
  className?: string
  mktuClass: MktuClassStore
  onEdit: (id: MktuClassStore['uuid']) => void
}
export const Card: FunctionComponent<CardProps> = observer(
  ({ className, mktuClass, onEdit }) => {
    const [visibleAll, setVisibleAll] = useState(false)

    const showAll = useCallback(() => {
      setVisibleAll(true)
    }, [])

    const collapse = useCallback(() => {
      setVisibleAll(false)
    }, [])

    const deleteWord = useCallback(
      (deleteName: MktuClassWord['word']) => {
        const newSelectedWordsNames = mktuClass.selectedWordsNames.filter(
          (name) => name !== deleteName
        )
        mktuClass.setSelectedWordsNames(newSelectedWordsNames)
      },
      [mktuClass]
    )

    const edit = useCallback(() => {
      onEdit(mktuClass.uuid)
    }, [mktuClass, onEdit])

    return (
      <div className={cn(className, styles.container)}>
        <div className={styles.title}>Класс {mktuClass.number}</div>
        <div className={styles.type}>
          {MKTU_CLASS_CATEGORY_TITLE[mktuClass.type] ?? ''}
        </div>
        <div className={styles.label}>Выбранные позиции класса</div>
        <div className={styles.selectedWords}>
          <SelectedWordsList
            words={mktuClass.selectedWords}
            onDelete={deleteWord}
            onShowAll={showAll}
            onCollapse={collapse}
            isExpanded={visibleAll}
            wordMaxWidth={null}
            isMultiline
          />
          <Button
            className={styles.editButton}
            onClick={edit}
            variant="primary"
            size="small"
          >
            {mktuClass.selectedWordsNames.length ===
            mktuClass.totalWordsCount ? (
              <>
                Изменить позиции{' '}
                <Icon className={styles.buttonIcon} name="pencil" />
              </>
            ) : (
              <>
                Дополнить позиции{' '}
                <Icon className={styles.buttonIcon} name="addSymbol" />
              </>
            )}
          </Button>
        </div>
      </div>
    )
  }
)
